import React from 'react';
import ReportFrame from '../ReportFrame';

export default class EvaluatorPaymentRecReport extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Evaluator Payment Rec Report'
          reportParams={reportParams}
          id='evaluatorpaymentrecreport'
          name='evaluatorpaymentrecreport'
          title='Evaluator Payment Rec Report'
        />
      </div>
    );
  }
}
